import { createFileRoute, Link } from "@tanstack/react-router";
import { useState } from "react";
import { api } from "../lib/api";

export const Route = createFileRoute("/gleymt-lykilord")({
  component: ForgotPasswordPage,
});

const inputClass =
  "mt-1 w-full rounded-lg border border-line px-3 py-2.5 text-sm outline-none focus:border-brand focus:ring-2 focus:ring-brand/20";

function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setLoading(true);
    try {
      await api.forgotPassword(email);
    } catch {
      void 0;
    } finally {
      setLoading(false);
      setSent(true);
    }
  }

  return (
    <div className="grid min-h-screen place-items-center bg-gradient-to-br from-[#0B1120] via-[#0D1B33] to-[#122b52] px-4">
      <div className="w-full max-w-md">
        <div className="mb-6 flex flex-col items-center text-center">
          <img
            src="/logo/atomika-mark-512px.png"
            alt="Atomika"
            className="mb-4 h-14 w-14"
          />
          <h1 className="text-2xl font-bold text-white">Gleymt lykilorð</h1>
          <p className="mt-1 text-sm text-white/50">
            Sláðu inn netfangið þitt og við sendum þér tímabundið lykilorð.
          </p>
        </div>

        <div className="rounded-2xl border border-white/10 bg-white/95 p-6 shadow-[0_24px_80px_rgba(0,0,0,.4)] backdrop-blur">
          {sent ? (
            <div className="space-y-4 text-center">
              <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-brand/10">
                <svg
                  width="28"
                  height="28"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#1E7BFF"
                  strokeWidth="1.8"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <rect x="3" y="5" width="18" height="14" rx="2" />
                  <path d="m3 7 9 6 9-6" />
                </svg>
              </div>
              <p className="text-sm text-ink">
                Ef netfangið er skráð hjá okkur höfum við sent tímabundið
                lykilorð þangað. Athugaðu pósthólfið þitt og skráðu þig svo inn.
              </p>
              <Link
                to="/login"
                className="inline-block w-full rounded-lg bg-brand px-4 py-2.5 font-semibold text-white transition hover:bg-brand-dark"
              >
                Áfram á innskráningu
              </Link>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-ink">
                  Netfang
                </label>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  autoComplete="username"
                  required
                  className={inputClass}
                />
              </div>

              <button
                type="submit"
                disabled={loading}
                className="w-full rounded-lg bg-brand px-4 py-2.5 font-semibold text-white transition hover:bg-brand-dark disabled:opacity-50"
              >
                {loading ? "Sendi…" : "Senda tímabundið lykilorð"}
              </button>
            </form>
          )}
        </div>

        <div className="mt-5 text-center text-[13px] text-white/40">
          <Link to="/login" className="text-white/40 hover:text-white/70">
            ← Til baka á innskráningu
          </Link>
        </div>
      </div>
    </div>
  );
}
